import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const shouldForwardProp = (prop: PropertyKey) =>
  !['minHeight', 'variant', 'empty'].includes(prop as string);

export const OpportunityAndRiskCardContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(1.5),
  overflow: 'hidden',
}));

interface OpportunityAndRiskCardHeaderProps {
  variant: 'opportunity' | 'risk';
}

export const OpportunityAndRiskCardHeader = styled(Box, {
  shouldForwardProp,
})<OpportunityAndRiskCardHeaderProps>(({ theme, variant }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1.5, 3),
  gap: theme.spacing(1),
  backgroundColor:
    variant === 'opportunity' ? theme.palette['mint-green'][50] : theme.palette.orange[50],
  borderTopLeftRadius: theme.spacing(1.5),
  borderTopRightRadius: theme.spacing(1.5),
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

interface OpportunityAndRiskCardContentProps {
  minHeight: string;
  gap: number;
  empty?: boolean;
  padding?: string;
}

export const OpportunityAndRiskCardContent = styled(Box, {
  shouldForwardProp,
})<OpportunityAndRiskCardContentProps>(({ theme, minHeight, gap = 1.5, empty, padding = 3 }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: empty ? 'center' : 'flex-start',
  justifyContent: empty ? 'center' : 'flex-start',
  gap: theme.spacing(gap),
  padding: theme.spacing(padding),
  minHeight,
  flex: 1,
  overflow: 'hidden',
  [theme.breakpoints.down('md')]: {
    gap: theme.spacing(gap),
  },
}));

export const OpportunityAndRiskCardContentEmpty = styled(Box)(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(3),
  textAlign: 'center',
}));
